export const dropdownList = [
  {
    text: "Buy",
    title: "Number Plate Search Engine",
    href: "/number-plates-search",
    icon: "search",
    listStyle: {
      width: "250px",
    },
    list: [
      {
        text: "Number Plate Search",
        href: "/number-plates-search",
        title: "Search different types of number plates",
      },
      {
        text: "Dateless Number Plate Search",
        href: "/dateless-number-plates",
        title: "Search datelessnumber plates",
      },
      {
        text: "Number Plate Builder",
        href: "/number-plate-builder",
        title: "Build your own number plate",
      },
      {
        text: "Cheap Registrations",
        href: "/search/search_results/navigation/contextual/listing/none/none/BARGAIN_PREFIX_PLATES/1/bargain_prefix",
        title: "Cheap Number Plates",
      },
      {
        text: "Physical Number Plates",
        href: "/buy/acrylic-number-plates/",
        title: "Physical Number Plates",
      },
      {
        text: "Search Ideas",
        href: "/searchideas",
        title: "Number Plate Search Ideas",
      },
      {
        text: "Name Number Plates",
        href: "/whats_in_a_name",
        title: "Name Based Number Plates",
      },
      {
        text: "Future Releases",
        href: "/future-releases",
        title: "Future number plate series",
      },
      {
        text: "Private Number Plates",
        href: "/private-number-plates",
        title: "Private Number Plates",
      },
      {
        text: "Gift Ideas",
        href: "/personalised-registration-gift",
        title: "Number Plate Gift Ideas",
      },
      {
        text: "Number Plates for Businesses",
        href: "/fleet-brand-registrations",
        title: "Number Plates for Businesses",
      },
      {
        text: "Types of DVLA Registrations",
        href: "/services/registration_types",
      },
      {
        text: "History of the Motor Vehicle",
        href: "/number-plates-information/history-of-the-motor-vehicle/",
        title: "History of the Motor Vehicle",
      },
      {
        text: "History of UK Number Plates",
        href: "/number-plates-information/history-of-uk-number-plates/",
        title: "History of UK Number Plates",
      },
      {
        text: "About Number Plates",
        href: "/numberplates",
        title: "New Reg on Number Plates",
      },
    ],
  },
  {
    text: "Sell",
    title: "Selling a Private Registration",
    href: "/valuations/newreg_valuations_form",
    icon: "add_circle_outline",
    listStyle: {
      width: "300px",
    },
    list: [
      {
        text: "Private Number Plate Valuation Form",
        href: "/valuations/newreg_valuations_form",
      },
      {
        text: "Valuation Terms & Conditions",
        href: "/valuations/commission_terms",
      },
    ],
  },
  {
    text: "Help <span class='lg-hidden'>& Services</span>",
    title: "New Reg Help",
    href: "/help",
    icon: "help_outline",
    listStyle: {
      width: "227px",
    },
    list: [
      { text: "Buying on Finance", href: "/number-plate-finance" },
      {
        text: "Physical Plate Information",
        href: "/services/dvla_number_plates",
      },
      { text: "Downloads", href: "/downloads" },
      { text: "General Help", href: "/help" },
      {
        text: "Frequently Asked Questions",
        href: "/services/frequently_asked_questions",
      },
      { text: "Retention Scheme", href: "/services/retention_scheme" },
      { text: "List Of VRO's", href: "/services/vehicle_registration_offices" },
      { text: "News and information", href: "/blog" },
      {
        text: "Code of Practice",
        href: "/help/regulations/cnda-code-of-practice",
      },
      { text: "Shipping Policy", href: "/help/regulations/shipping-policy" },
      { text: "Returns Policy", href: "/help/regulations/returns-policy" },
      { text: "About New Reg", href: "/help/about-new-reg" },
      { text: "Contact us", href: "/help/contact" },
    ],
  },
];
